const CLICKBANK_HOP = "https://fbb3fpv745sq39ufzaqeh7ts3m.hop.clickbank.net/?&traffic_source=googleads&traffic_type=ppc&campaign=jointgen50plus-1&creative=landingpage&adgroup=articulacoes50plus-1&ad=review_1&extclid=googleleads";

export default function CtaSection({
  text,
  href = CLICKBANK_HOP,
  variant = "primary",
}: {
  text: string;
  href?: string;
  variant?: "primary" | "secondary";
}) {
  const handleClick = () => {
    if (typeof window !== "undefined" && (window as Record<string, unknown>).dataLayer) {
      ((window as Record<string, unknown>).dataLayer as Array<Record<string, unknown>>).push({
        event: "cta_click",
        cta_text: text,
      });
    }
  };

  const baseClasses =
    "inline-flex items-center justify-center px-10 py-5 rounded-full font-bold text-lg uppercase tracking-wide transition-all duration-300 whitespace-nowrap cursor-pointer btn-hover-lift";
  const variantClasses =
    variant === "primary"
      ? "bg-primary-500 text-foreground-950 hover:bg-primary-600 animate-cta-pulse"
      : "bg-background-50 text-foreground-900 border border-foreground-200 hover:bg-background-100";

  return (
    <div className="flex justify-center py-10 md:py-14">
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClick}
        className={`${baseClasses} ${variantClasses}`}
      >
        {text}
        <i className="ri-arrow-right-line ml-2" />
      </a>
    </div>
  );
}